import { ref } from 'vue';

const isOpen = ref(false);
const msgSnack = ref('');
const timeoutSnack = ref(5000);
const colorSnack = ref('');


// Composable function useSnackbar
export function useSnackbar() {
    return {
        isOpen,
        message: msgSnack,
        timeout: timeoutSnack,
        color: colorSnack,
        open(textMessage: string, timeout: number | string, color: string) {
            isOpen.value = true;
            msgSnack.value = textMessage;
            timeoutSnack.value = +timeout;
            colorSnack.value = color;
        },
        close() {
            isOpen.value = false;
        },
    };
}

export type SnackbarType = ReturnType<typeof useSnackbar>;